"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports["default"] = void 0;

var _createSvgIcon = _interopRequireDefault(require("../createSvgIcon"));

var _PlusRound = _interopRequireDefault(require("@rsuite/icon-font/lib/status/PlusRound"));

// Generated by script, don't edit it please.
var PlusRound = (0, _createSvgIcon["default"])({
  as: _PlusRound["default"],
  ariaLabel: 'plus round',
  category: 'status',
  displayName: 'PlusRound'
});
var _default = PlusRound;
exports["default"] = _default;
module.exports = exports.default;